import styled from 'styled-components';

import { Tooltip } from '@/components/basicComponents/tooltip';
import { themeVar } from '@/styles/theme';
import { Status } from './index';

interface NextStepStatusRowProps {
  status: string;
  isMobile?: boolean;
  nextStepTitle?: string;
}

export const NextStepStatusRow = ({ status, isMobile = false, nextStepTitle = 'Next step:' }: NextStepStatusRowProps) => {
  if (isMobile) {
    return (
      <Tooltip title={status}>
        <Row>
          <NextStep>{nextStepTitle}</NextStep>
          <Status isMobile={isMobile} color={themeVar('context.light')}>
            {status}
          </Status>
        </Row>
      </Tooltip>
    );
  }

  return (
    <Row>
      <NextStep>{nextStepTitle}</NextStep>
      <Status isMobile={isMobile} color={themeVar('context.light')}>
        {status}
      </Status>
    </Row>
  );
};
const Row = styled.div`
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  border-radius: 4px;
  padding: 7px 12px;
  background: ${themeVar('action.active')};
`;

const NextStep = styled.span`
  font-family: 'Blinker';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: ${themeVar('context.light')};
  text-transform: uppercase;
`;
